import React from 'react';
import styled from '@emotion/styled';

import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { IMAGES_MAP } from './constants';
import { SCREEN_BREAKPOINTS } from '../../constants';
import { HeaderWaveIcon } from '../Icons';
import { HeaderContent, HeaderImage } from './components';

const HeaderSection = styled.section`
  background: ${COLOR_GREEN};
`;
const HeaderTopContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 5%;
  width: 100%;

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    > div:first-child,
    > div:last-child {
      display: none;
    }
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    padding: 0 5% 20px;
  }
`;
const HeaderBottomContainer = styled.div`
  background: ${COLOR_GREEN};
  display: flex;
  height: 0;
  justify-content: space-between;
  padding: 0 20% 13.06%; // Ratio of SVG
  position: relative;
  width: 100%;

  svg {
    bottom: -6px;
    height: 100%;
    left: 0;
    position: absolute;
    width: 100%;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    padding: 0 5% 13.06%; // Ratio of SVG
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    > div:nth-child(2) {
      display: none;
    }
  }
`;

export const Header = () => {
  return (
    <HeaderSection>
      <HeaderTopContainer>
        <HeaderImage image={IMAGES_MAP.headerOne} />
        <HeaderContent />
        <HeaderImage image={IMAGES_MAP.headerTwo} />
      </HeaderTopContainer>
      <HeaderBottomContainer>
        <HeaderImage image={IMAGES_MAP.headerThree} />
        <HeaderImage image={IMAGES_MAP.headerFour} />
        <HeaderImage image={IMAGES_MAP.headerFive} />
        <HeaderWaveIcon />
      </HeaderBottomContainer>
    </HeaderSection>
  );
};
